import http from './http'
import { handleHttpError } from './httpHelpers'

// export function getRegionsService(data) {
//     let data = {
//         "customFunc": {
//             "name": "cf_creaAstaDaProdotto",
//             "param": { ...data }
//         }
//     }

//     return http.post('/api/v1/asta/customfunc/', data, { skipAuthRefresh: true }).then(res => {
//         return res.data
//     }).catch(e => {
//         return handleHttpError(e)
//     })
// }

export function getRegionsService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_avviaAsta",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/asta/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function addBidService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_faiOfferta",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/astaofferta/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function lockBidService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_bloccaAsta",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/asta/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function closeAuctionService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_chiudiAsta",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/asta/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function deleteAuctionService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_eliminaAsta",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/asta/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}
export function getLatestAuctionOffersService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniOfferte",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/astaofferta/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}
export function getBidDetailService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniAsta",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/asta/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}